import { useState } from "react";
import {
  addValorationURL,
  deleteValorationURL,
} from "../../utils/ConstantsURL";
import { toastAlert } from "../../utils/AlertContext";

export const useValoration = ({ token, refresh }) => {
  const [valoration, setValoration] = useState("");

  const sendValoration = async (formData) => {
    try {
      const response = await fetch(addValorationURL(), {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (response.ok) {
        setValoration(data);
        toastAlert("Valoración agregada", "success");
        refresh();
      } else {
        console.log(data.message);
      }
    } catch {
      console.log("Error en la petición");
    }
  };
  return { valoration, setValoration, sendValoration };
};

export const useDeleteValoration = ({ token, refresh }) => {
  const deleteValoration = async (id) => {
    try {
      const response = await fetch(deleteValorationURL(id), {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.ok) {
        toastAlert("Valoración eliminada", "success");
        refresh();
      } else {
        console.log(data.message);
      }
    } catch {
      console.log("Error en la petición");
    }
  };
  return { deleteValoration };
};
